module.exports = __webpack_public_path__ + "img/maYiJinFu.fc2033c6.png";